import Vue from 'vue'
import App from './App.vue'

import HomePage from './components/HomePage.vue'
import CreateNewSite from './components/CreateNewSite.vue'
import ViewSites from './components/ViewSites.vue'
import SuccessfullyCreateSite from './components/SuccessfullyCreateSite.vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Install BootstrapVue
Vue.use(BootstrapVue)

// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

import VueTypedJs from 'vue-typed-js'

Vue.use(VueTypedJs)

Vue.config.productionTip = false

import VueRouter from "vue-router";

Vue.use(VueRouter)

const router = new VueRouter({
  routes: [
    { path: '/', component: HomePage },
    { path: '/new_site', component: CreateNewSite },
    { path: '/sites', component: ViewSites },
    { path: '/created-new-site-successfully', component: SuccessfullyCreateSite },
  ]
});

import GSignInButton from 'vue-google-signin-button'
Vue.use(GSignInButton)

import vueDebounce from 'vue-debounce'
 
Vue.use(vueDebounce)

Vue.use(require('vue-moment'));

import VueCodemirror from 'vue-codemirror'

// import base style
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/monokai.css'
import 'codemirror/mode/yaml/yaml.js'

Vue.use(VueCodemirror);

import VueToastr from "vue-toastr";
Vue.use(VueToastr, {

});

const app = new Vue({
  router: router,
  render: h => h(App),
}).$mount('#app');

function redirect_if_unauth(router) {
	const authed = localStorage.getItem('auth_token') !== null;

	if(!authed && app.$route.path != '/') {
		router.push('/');
	}
}

redirect_if_unauth(router);

export {app}